import { DatePicker as DatePickerBase } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';

import useDatePickerFormat from 'hooks/useDatePickerFormat';
import dateFnsGenerateConfig from 'polyfill/dateFnsGenerateConfig';

const DatePicker = DatePickerBase.generatePicker(dateFnsGenerateConfig);

/**
 * @typedef {Object} TimePickerProps
 * @property {string?} className
 * @property {string?} placeholder
 * @property {function?} onChange
 */

/** @type {React.FC<TimePickerProps & import('antd/lib/time-picker').TimePicker>} */
const FBTimePicker = ({ placeholder, ...rest }) => {
  const intl = useIntl();
  const { timeFormat } = useDatePickerFormat();

  return (
    <DatePicker.TimePicker
      showNow={false}
      needConfirm={false}
      format={timeFormat}
      placeholder={placeholder && intl.formatMessage({ id: placeholder })}
      {...rest}
    />
  );
};

export default FBTimePicker;
